"use client";

import { useChat } from "@/providers/chat-provider";
import { useSearchParams } from "next/navigation";
import { useEffect } from "react";

const OpenChatTrigger = () => {
	const searchParams = useSearchParams();
	const { handleOpenChatWidget, handleOpenChat } = useChat();
	const openChatAreaFromSearchParams = searchParams.get("chat");
	const chatIdFromSearchParams = searchParams.get("chatId");

	useEffect(() => {
		if (openChatAreaFromSearchParams && chatIdFromSearchParams) {
			handleOpenChatWidget();

			handleOpenChat({ uniqueChatId: chatIdFromSearchParams });
		}
	}, [openChatAreaFromSearchParams, chatIdFromSearchParams, handleOpenChat, handleOpenChatWidget]);

	return <></>;
};

export default OpenChatTrigger;
